import { PriceStatus } from '@toggle/helpers';
import { format } from 'date-fns';
import { t } from 'i18next';
import React from 'react';

import * as S from './PriceSummaryDisplay.styles';

export interface PriceColumnConfig {
  price?: string;
  currency: string;
  label?: React.ReactNode;
}

export interface PriceSummaryDisplayProps {
  priceColumn?: PriceColumnConfig;
  percentageChange?: number;
  prevCloseTime?: string;
}

export const PriceSummaryDisplay = ({
  priceColumn,
  percentageChange,
  prevCloseTime,
}: PriceSummaryDisplayProps) => {
  const formatPercentage = (value: number) => {
    const sign = value >= 0 ? '+' : '';
    return `${sign}${value.toFixed(2)}%`;
  };

  if (!priceColumn || priceColumn.price === undefined) {
    return null;
  }

  return (
    <>
      <S.ProportionChangeColumn>
        <S.PriceRow>
          <S.ProportionPrice>{priceColumn.price}</S.ProportionPrice>
          <S.ProportionCurrency>{priceColumn.currency}</S.ProportionCurrency>
        </S.PriceRow>
        {priceColumn.label}
      </S.ProportionChangeColumn>
      {percentageChange !== undefined && (
        <S.ProportionChangeColumn>
          <S.PercentageChange
            $status={
              percentageChange >= 0
                ? PriceStatus.Positive
                : PriceStatus.Negative
            }
          >
            {formatPercentage(percentageChange)}
          </S.PercentageChange>
          {prevCloseTime && (
            <S.DateSpan>
              {t('analyze:analysis.sinceDateClose', {
                date: format(prevCloseTime, 'MMM d'),
              })}
            </S.DateSpan>
          )}
        </S.ProportionChangeColumn>
      )}
    </>
  );
};
